export const environment = {
  production: true,

  // Test server
  //baseUrl: "https://213.199.43.99:8432",

  // baseUrl: "https://api.sesameutilityservices.com",

  // baseUrl: "https://dev.sesameutilityservices.com",

  // baseUrl:"http://159.65.30.149:9000"

  baseUrl: "https://api.digitalmmita.com",

  // baseUrl: "http://localhost:8432",
};

//046900308613

// my server ip is: 159.65.91.46

// i have domain: api.sesameutilityservices.com

// i want to setup cerbot ssl for the above domain

// then use the details here:

// server {
//   listen 443 ssl;
//   server_name api.sesameutilityservices.com;

//   ssl_certificate ....;
//   ssl_certificate_key ....;

//   location / {
//       proxy_pass http://sesameus-be:8432; # Proxy to backend container
//       proxy_set_header Host $host;
//       proxy_set_header X-Real-IP $remote_addr;
//       proxy_set_header X-Forwarded-For $proxy_add_x_forwarded_for;
//       proxy_set_header X-Forwarded-Proto $scheme;
//   }
// }

// can you generate the whole implementation with all steps!!
